import { useOrgStore } from '@/stores/orgStore';

export function useOrganization() {
  const { currentOrg, currentMembership, isLoading, hasHydrated } = useOrgStore();

  const isAdmin = currentMembership?.is_admin ?? false;
  const isManager = currentMembership?.role === 'manager' || isAdmin; // DEPRECATED: kept for backward compatibility
  const isMember = !!currentMembership;

  return {
    organization: currentOrg,
    membership: currentMembership,
    organizationId: currentOrg?.id,
    role: currentMembership?.role, // DEPRECATED: use isAdmin instead
    isLoading,
    hasHydrated,
    isAdmin,
    isManager, // DEPRECATED: use isAdmin or custom roles instead
    isMember,
    hasRole: (role: 'admin' | 'manager' | 'member') => {
      // DEPRECATED: use isAdmin or check permissions via usePermissions hook
      if (!currentMembership) return false;
      if (role === 'admin') return isAdmin;
      if (role === 'manager') return isManager;
      if (role === 'member') return true; // Everyone has at least member access
      return false;
    },
  };
}
